var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 44,
    viewBox: "0 0 172 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 10C0 4.47715 4.47715 0 10 0H162C167.523 0 172 4.47715 172 10V34C172 39.5228 167.523 44 162 44H10C4.47716 44 0 39.5228 0 34V10Z",
    fill: "url(#paint0_linear_1280_314)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4069 18.7759C78.079 18.7759 75.3666 21.3072 75.3666 24.7936C75.3666 28.2587 78.079 30.8112 81.4069 30.8112C84.7362 30.8112 87.4486 28.2587 87.4486 24.7936C87.4472 21.3072 84.7348 18.7759 81.4069 18.7759ZM81.4069 28.4426C79.583 28.4426 78.0111 26.9386 78.0111 24.795C78.0111 22.6287 79.5845 21.1473 81.4069 21.1473C83.2307 21.1473 84.8027 22.6287 84.8027 24.795C84.8027 26.9372 83.2307 28.4426 81.4069 28.4426ZM68.2283 18.7759C64.9004 18.7759 62.188 21.3072 62.188 24.7936C62.188 28.2587 64.9004 30.8112 68.2283 30.8112C71.5576 30.8112 74.27 28.2587 74.27 24.7936C74.27 21.3072 71.5576 18.7759 68.2283 18.7759ZM68.2283 28.4426C66.4045 28.4426 64.8325 26.9386 64.8325 24.795C64.8325 22.6287 66.4059 21.1473 68.2283 21.1473C70.0521 21.1473 71.6241 22.6287 71.6241 24.795C71.6255 26.9372 70.0521 28.4426 68.2283 28.4426ZM52.5538 20.6238V23.1763H58.6635C58.4809 24.6124 58.0027 25.6609 57.2726 26.3896C56.384 27.2781 54.9932 28.2587 52.5538 28.2587C48.793 28.2587 45.8528 25.2265 45.8528 21.4657C45.8528 17.7048 48.793 14.6726 52.5538 14.6726C54.5828 14.6726 56.0642 15.4706 57.158 16.4965L58.9592 14.6953C57.4311 13.2365 55.4035 12.1201 52.5538 12.1201C47.4021 12.1201 43.071 16.3139 43.071 21.4657C43.071 26.6174 47.4021 30.8112 52.5538 30.8112C55.3341 30.8112 57.4325 29.8986 59.0724 28.1894C60.759 26.5028 61.2839 24.1314 61.2839 22.217C61.2839 21.6255 61.2386 21.078 61.1466 20.6224H52.5538V20.6238ZM116.661 22.6061C116.16 21.2619 114.632 18.7759 111.509 18.7759C108.409 18.7759 105.833 21.2152 105.833 24.7936C105.833 28.1667 108.387 30.8112 111.805 30.8112C114.563 30.8112 116.159 29.1246 116.821 28.1441L114.769 26.7758C114.086 27.779 113.151 28.4398 111.805 28.4398C110.461 28.4398 109.503 27.8243 108.887 26.616L116.934 23.2881L116.661 22.6061ZM108.454 24.6124C108.387 22.2863 110.256 21.102 111.601 21.102C112.65 21.102 113.538 21.627 113.835 22.3783L108.454 24.6124ZM101.913 30.4476H104.556V12.7597H101.913V30.4476ZM97.5808 20.1215H97.4903C96.8974 19.414 95.757 18.7759 94.3223 18.7759C91.3127 18.7759 88.555 21.4204 88.555 24.8176C88.555 28.1908 91.3127 30.8126 94.3223 30.8126C95.7584 30.8126 96.8974 30.1745 97.4903 29.4458H97.5808V30.3117C97.5808 32.6138 96.3498 33.8448 94.3675 33.8448C92.7489 33.8448 91.7457 32.6831 91.3354 31.7026L89.0333 32.6605C89.694 34.2551 91.4485 36.2162 94.3675 36.2162C97.4676 36.2162 100.089 34.3924 100.089 29.9467V19.1424H97.5822V20.1215H97.5808ZM94.5501 28.4426C92.7262 28.4426 91.1995 26.9145 91.1995 24.8176C91.1995 22.6966 92.7262 21.1473 94.5501 21.1473C96.3498 21.1473 97.7633 22.6966 97.7633 24.8176C97.7633 26.9145 96.3498 28.4426 94.5501 28.4426ZM129.047 12.7597H122.721V30.4476H125.36V23.7465H129.046C131.972 23.7465 134.85 21.6284 134.85 18.2538C134.85 14.8792 131.973 12.7597 129.047 12.7597ZM129.115 21.2845H125.36V15.2216H129.115C131.089 15.2216 132.21 16.8559 132.21 18.2538C132.21 19.6234 131.089 21.2845 129.115 21.2845ZM145.432 18.7448C143.52 18.7448 141.541 19.5866 140.722 21.4529L143.065 22.4306C143.566 21.4529 144.5 21.1332 145.477 21.1332C146.843 21.1332 148.231 21.9524 148.253 23.4083V23.5909C147.775 23.3178 146.751 22.9089 145.5 22.9089C142.974 22.9089 140.402 24.2969 140.402 26.8905C140.402 29.2576 142.473 30.7815 144.794 30.7815C146.568 30.7815 147.547 29.9849 148.161 29.051H148.252V30.4164H150.802V23.6347C150.803 20.4964 148.457 18.7448 145.432 18.7448ZM145.112 28.4384C144.249 28.4384 143.042 28.0054 143.042 26.9357C143.042 25.5703 144.545 25.0468 145.842 25.0468C147.001 25.0468 147.549 25.2973 148.253 25.6383C148.048 27.2781 146.637 28.4384 145.112 28.4384ZM160.086 19.131L157.06 26.7999H156.969L153.828 19.131H150.984L155.694 29.8491L153.009 35.8115H155.762L163.022 19.131H160.086ZM136.307 30.4476H138.946V12.7597H136.307V30.4476Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1280_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4931 8.42345C9.18318 8.75147 9 9.26055 9 9.91979V33.4736C9 34.1339 9.18318 34.6419 9.4931 34.9699L9.57191 35.0466L22.7663 21.8522V21.6967V21.5412L9.57191 8.3457L9.4931 8.42345Z",
    fill: "url(#paint1_linear_1280_314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1638 26.2506L22.7664 21.8511V21.6956V21.5401L27.1649 17.1416L27.2639 17.198L32.475 20.1588C33.9628 21.0044 33.9628 22.3878 32.475 23.2345L27.2639 26.1953L27.1638 26.2506Z",
    fill: "url(#paint2_linear_1280_314)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1280_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2639 26.1949L22.7653 21.6963L9.49316 34.9695C9.98307 35.4892 10.7935 35.5531 11.7063 35.0356L27.2639 26.1949Z",
    fill: "url(#paint3_linear_1280_314)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2639 17.1975L11.7063 8.35792C10.7935 7.83926 9.98307 7.90423 9.49316 8.42395L22.7664 21.6972L27.2639 17.1975Z",
    fill: "url(#paint4_linear_1280_314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1280_314",
    x: 9,
    y: 8,
    width: 24.5908,
    height: 27.3926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.212238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1280_314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.212238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1280_314",
    result: "effect2_innerShadow_1280_314"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1280_314",
    x: 9.49316,
    y: 21.6963,
    width: 17.7708,
    height: 13.6963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.212238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1280_314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1280_314",
    x1: -101.726,
    y1: 1.57143,
    x2: -101.726,
    y2: 45.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1280_314",
    x1: 21.5967,
    y1: 9.67058,
    x2: 3.72372,
    y2: 27.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1280_314",
    x1: 34.4117,
    y1: 21.6956,
    x2: 8.64282,
    y2: 21.6956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1280_314",
    x1: 24.8209,
    y1: 24.1393,
    x2: 0.58286,
    y2: 48.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1280_314",
    x1: 6.15052,
    y1: 0.583131,
    x2: 16.9735,
    y2: 11.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/playStoreIcon.b9449127d5ac648880c577e46bf496aa.svg";
export { ForwardRef as ReactComponent };